import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbMetaTrader5 = () => {
  return (
    <div
      className="ht__bradcaump__area__platform"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>MetaTrader 5 (MT5)</h1>
              <p>
                Trade without trade-offs, experience the next generation of
                multi-asset trading with The Pips MT5.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Download Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbMetaTrader5.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbMetaTrader5;
